var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSortDesc = function SvgSortDesc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.598 3.12 12h5.76L6 15.598ZM6 18l6-7.5H0L6 18ZM3.12 6 6 2.401 8.88 6H3.12ZM0 7.5h12L6 0 0 7.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.5.804 10.75h10.392L6 17.5Z"
  })));
};
export default SvgSortDesc;